import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { jsx as _jsx } from "react/jsx-runtime";
const TileMessageContent = ({
  children
}) => /*#__PURE__*/_jsx(MediaBody, {
  children: children
});
TileMessageContent.displayName = 'TileMessageContent';
export default TileMessageContent;